import { IWizardStep } from "../../../../wizard/types";
import { validator } from "./validator";
import ApplyApplicationForm from "./Content";

export const applyAsStep1: IWizardStep = {
  width: "720px",
  titleConfig: {
    titleText: "Apply",
  },
  content: ApplyApplicationForm,
  validator: validator,
  stepName: "step1",
};
